import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { getUrlFaviconSrc } from '../common/util';
import { ActionAreaBtn } from './ActionAreaFab';

export interface ExternalLinkOverlayProps {
	urls: string[];
}

/** Favicon buttons pinned over the right edge of a `position: relative` parent, one per URL. */
export function ExternalLinkOverlay({ urls }: ExternalLinkOverlayProps) {
	return <Box sx={{position: 'absolute', top: 0, bottom: 0, right: 4, display: 'flex', alignItems: 'center', gap: 0.5}}>
		{urls.map((url) => (
			<Tooltip key={url} title={`Open ${url}`} disableInteractive>
				<ActionAreaBtn
					onClick={(e) => {
						e.stopPropagation();
						window.open(url, '_blank', 'noopener,noreferrer');
					}}
				>
					<Box component='img' src={getUrlFaviconSrc(url)} alt='' sx={{width: 16, height: 16, borderRadius: '2px'}} />
				</ActionAreaBtn>
			</Tooltip>
		))}
	</Box>;
}
